declare const __BUILD_ID__: string | undefined;

export const BUILD_ID =
  typeof __BUILD_ID__ !== 'undefined' && __BUILD_ID__
    ? __BUILD_ID__
    : 'local';
// Library version
export const LIB_VERSION = BUILD_ID;
